import React from 'react'
import "./CreateAccordianlink.css"
import * as BsXLg from "react-icons/bs";
import { Link } from 'react-router-dom';
import pic21 from "../../img/pic21.jpg";
import * as IoIosArrowBack from "react-icons/io";
import { MdMargin } from 'react-icons/md';
import Form from 'react-bootstrap/Form';


const CreateAccordianlink = () => {
    return (
        <div className="modalBackgroundesss">
            <div className="modalContainerswww">




                <div className='divflxdiv'>
                    <img src={pic21} className="divrightimg"></img>
                    <div className="divfontgmails">
                        <span className="rightdivallmethod"><b>1-on-1 Meeting Agenda </b></span>
                        <span >by Sarah goff-Dupont,princi...</span>
                    </div>
                </div>


                <div className="divanotherdivtext">
                    <span>Whether it's shipping a product
                        or running through iterations of
                        a project plan, this agile board template
                        will help you get things done.</span>
                </div>
                <hr style={{ width: "250px", border: '1px solid darkgray', marginTop: "0.5rem" }} />

                <label className='lablinputtext' for="myInput">Board Title</label>
                <input id="myInput" type="text" />
                <label className='lablinputtext' for="myInput">Visibilty</label>
                <div class="Workspacess">
                    <select className='slecoptondiv'>
                        <option value="0">Workspace</option>
                        <option value="1">Private</option>
                        <option value="2">WorkSpace</option>
                        <option value="2">Public</option>

                    </select>
                </div>
                <div>
                    <Form className='checkbivbox'>
                        {['checkbox'].map((type) => (
                            <div key={`Keep-${type}`} className="mb-3">
                                <Form.Check
                                    type={type}
                                    id={`Keep-${type}`}
                                    label={`Keep ${type}`}
                                />


                            </div>
                        ))}
                    </Form>
                </div>
                <div className="divanotherdivtextify">
                    <span >Activity and members will not be copied to the new board.</span>
                </div>

                <div className='btncre2btn'>
                    <button className='btncrebtn'>Create</button>
                </div>
            </div>
        </div>
    )
}

export default CreateAccordianlink